import React, { FC, useEffect, useState, CSSProperties } from 'react';
import { socialPlatformsIcons } from '../../../investigate/Content/routes/collections/Collection/constants';

interface SocialIconProps {
    platform: string;
    styles?: CSSProperties;
}

const unknown = 'unknown';

const SocialIcon: FC<SocialIconProps> = ({ platform, styles }) => {
    const [socialPlatform, setSocialPlatform] = useState(null);

    useEffect(() => {
        let result;
        const icon = socialPlatformsIcons.get(platform);

        try {
            result = require(`../../../common/images/social-icons/${icon}.svg`);
        } catch (e) {
            result = require(`../../../common/images/social-icons/${unknown}.svg`);
        }

        setSocialPlatform(result);
    }, [platform]);

    return <img src={socialPlatform} alt={platform} style={{ ...styles }} />;
};

export default SocialIcon;
